import { FluidProxyInterface } from './fluid-proxy.interface';

export const proxies: FluidProxyInterface[] = [];
